<template>
    <div>
        <div class="alert border-danger bg-transparent text-secondary fade show billing-alert"
             role="alert" v-if="show_notif">
            <div class="d-flex align-items-start">
                <div class="alert-icon mr-3">
					<span class="icon-stack icon-stack-md">
						<i class="base-7 icon-stack-3x color-danger-900"></i>
						<i class="fal fa-times icon-stack-1x text-white"></i>
					</span>
                </div>
                
                <div class="flex-1">
                    <span class="h5 color-danger-900 d-block mb-1">Увага, Вам потрбіно заповнити Декларування конфікту інтересів за рік<div>
                        <a :href="info.url_to">Перейти</a>
                    </div>
                    </span>
                </div>
            
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "notification",
    components: {},
    data() {
        return {
            is_load: false,
            info : {
                show_notification : false,
                url_to : "",
            }
        }
    },
    
    created() {
        this.load_notification();
    },
    
    methods: {
        
        async load_notification() {
            this.is_load = true;
            await api.get('/declaration/notification').then(({data}) => {
                this.is_load = false;
                this.info = data.data;
            }).catch(() => {
                this.is_load = false;
            });
        },
    },
    
    computed: {
        show_notif() {
            return this.info.show_notification;
        },
    }
}
</script>

<style scoped>
.content__sandbox {
    border-top: 2px solid #927ee7;
    display: flex;
    flex-direction: row;
    justify-content: center;
    position: fixed;
    width: 100%;
    z-index: 9000;
    top: 0;
    left: 0;
}

.content__sandbox__border {
    font-size: 13px;
    color: #fff;
    padding: 2px;
    background: #927ee7;
}

.billing-alert {
    border-width: 1px;
    border-style: solid;
    border-radius: 6px;
}

.bill-main-line {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px;
    font-size: 15px;
}

.bill-usd {
    color: #6c757d;
}

.bill-eq {
    opacity: 0.7;
}

.bill-uah {
    font-size: 16px;
    color: #343a40;
}

.bill-extra-box {
    background: rgba(220, 53, 69, 0.04);
    border: 1px solid rgba(220, 53, 69, 0.15);
    border-radius: 8px;
    padding: 10px 12px;
    max-width: 620px;
}

.bill-extra-title {
    font-weight: 600;
    color: #b02a37;
    margin-bottom: 8px;
}

.bill-extra-row {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 12px;
    padding: 6px 0;
    border-top: 1px dashed rgba(0, 0, 0, 0.08);
}

.bill-extra-row:first-of-type {
    border-top: 0;
    padding-top: 0;
}

.bill-extra-left {
    display: flex;
    flex-direction: column;
}

.bill-extra-comment {
    font-size: 14px;
    color: #343a40;
}

.bill-extra-date {
    font-size: 12px;
    color: #6c757d;
    margin-top: 2px;
}

.bill-extra-right {
    display: flex;
    align-items: center;
    gap: 10px;
    white-space: nowrap;
}

.bill-extra-usd {
    font-size: 13px;
    color: #6c757d;
}

.bill-extra-uah {
    font-weight: 600;
    color: #dc3545;
}

.bill-extra-total {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 8px;
    padding-top: 8px;
    border-top: 1px solid rgba(0, 0, 0, 0.08);
    font-size: 14px;
}

.bill-total-box {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    background: #fff;
    border: 1px solid rgba(40, 167, 69, 0.2);
    border-radius: 8px;
    padding: 8px 12px;
}

.bill-total-label {
    color: #495057;
}

.bill-total-value {
    color: #198754;
    font-size: 16px;
}

.billing-actions {
    display: flex;
    flex-direction: column;
    margin-left: 15px;
}
</style>
